var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-cell-group',{attrs:{"inset":""}},[_c('van-field',{attrs:{"rows":"1","autosize":"","type":"textarea"},domProps:{"innerHTML":_vm._s(_vm.license)}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5dd31538","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/user/UserService.vue
// module id = 525
// module chunks = 1